import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'booking-status',
  templateUrl: './booking-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe, TranslateModule],
})
export class BookingStatusComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);


  constructor() {}

}
